import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Route, Routes, useLocation, useNavigate, useResolvedPath } from 'react-router-dom';
import HomeLayout from '../Pages/HomeContainer/HomeLayout';
import DashboardLayout from '../Pages/ProtectedContainer/DashboardLayout';
import APIService from '../Services/API/APIService';
import NotFound from '../Components/NotFound';
import { Dimmer, Loader } from 'semantic-ui-react';

const AuthRoute = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const url = useResolvedPath("").pathname;
  const location = useLocation();
  const navigateRef = useRef(navigate); 

  const checkAuthentication = useCallback(async (isSubscribed) => {
    try {

      const authResponse = await APIService.checkAuth();
      if (isSubscribed && authResponse) {
        APIService.storeUser(authResponse.user);
        const role = authResponse?.user?.group[0];
      
        switch (role) {
          case 'ADMIN':
          navigateRef.current(location.pathname.startsWith('/staff') ? location.pathname : `${url}staff`, { replace: true });
            break;
          case 'TREASURER':
            navigateRef.current(location.pathname.startsWith('/backoffice') ? location.pathname : `${url}backoffice`, { replace: true });
            break;
          case 'SUPERADMIN':
            navigateRef.current(location.pathname.startsWith('/staff') ? location.pathname : `${url}staff`, { replace: true });
            break;
          case 'COOPERATOR':
          case 'CUSTOMER':
          case 'GUEST':
          default:
            navigateRef.current(location.pathname.startsWith('/customer') ? location.pathname : `${url}customer`, { replace: true });
            break;
        }
      } else if (isSubscribed) {
    
        navigateRef.current(location.pathname !== '/'? location.pathname : `${url}customer`);
      }
    } catch (error) {
      await APIService.signOut();
      if (isSubscribed) {
        navigateRef.current(location.pathname !== '/'? location.pathname : `${url}customer`);
      }
    } finally {
      if (isSubscribed) setLoading(false);
    }
  }, [url,location.pathname]);

  useEffect(() => {
    let isSubscribed = true;
    checkAuthentication(isSubscribed);
    return () => {
      isSubscribed = false;
    };
  }, [checkAuthentication]);

  return (
    <div style={{ flex: 1, justifyContent: "center", alignContent: "center" }}>
      {loading ? (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      ) : (
        <Routes>
          <Route path="staff/*" element={<DashboardLayout />} />
          <Route path="backoffice/*" element={<DashboardLayout />} />
          <Route path="customer/*" element={<HomeLayout />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </div>
  );
};

export default AuthRoute;
